import React, { useCallback } from "react";
import { Icon } from "@washingtonpost/wpds-icon";
import { styled } from "@washingtonpost/wpds-theme";
import ChevronLeft from "@washingtonpost/wpds-assets/asset/chevron-left";
import { VideoEvents } from "../../globals";
import PropTypes from "prop-types";
import { useVideoElementRefContext } from "../../orca/contexts/VideoElementRefContext";

const GoBackButtonWrapper = styled("div", {
  width: "100%",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "flex-start"
});

const StyledGoBackButton = styled("span", {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  zIndex: 999,
  color: "#FFF",
  cursor: "pointer",
  top: "$150",
  left: "15px",
  fontWeight: "$regular"
});

export const GoBackButton = ({
  isCarousel,
  closeCarousel,
  closeFullscreen
}) => {
  const videoElementRef = useVideoElementRefContext();

  const handleBack = useCallback(
    e => {
      e.stopPropagation();

      if (isCarousel) {
        closeCarousel();
        return;
      }

      closeFullscreen();

      const fullscreenEvent = new Event(VideoEvents.UNFULLSCREEN);
      videoElementRef.current.dispatchEvent(fullscreenEvent);
    },
    [isCarousel, closeCarousel, closeFullscreen, videoElementRef]
  );

  return (
    <GoBackButtonWrapper
      css={{
        display: "none",
        "@sm": {
          display: "flex"
        }
      }}
    >
      <StyledGoBackButton onClick={handleBack} data-testid="go-back-button">
        <Icon size="100">
          <ChevronLeft />
        </Icon>
        &nbsp;
        <small style={{ fontWeight: "$regular" }}>
          <b>Go back</b>
        </small>
      </StyledGoBackButton>
    </GoBackButtonWrapper>
  );
};

GoBackButton.propTypes = {
  isCarousel: PropTypes.bool,
  closeCarousel: PropTypes.func,
  closeFullscreen: PropTypes.func
};
